import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoLarge from '../../assets/new-design/logo-large.png';
import './AppFooter.scss';

export type FooterVariant = 'dark' | 'simple';

interface Props {
  variant: FooterVariant;
}

export function AppFooter({ variant }: Props) {
  const navigate = useNavigate();

  if (variant === 'dark') {
    return (
      <footer className="app-footer app-footer--dark">
        <div className="app-footer__dark-inner">
          <div>
            <img src={logoLarge} alt="WashPass" className="app-footer__logo" />
          </div>
          <div className="app-footer__links">
            <a
              href="https://wash.app.br/client-privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="app-footer__link"
            >
              Política de privacidade
            </a>
            <span className="app-footer__link" onClick={() => navigate('/fale-conosco')}>
              Entre em contato
            </span>
            <span className="app-footer__link" onClick={() => navigate('/')}>
              Área do cliente
            </span>
          </div>
        </div>
        <div className="app-footer__copyright-bar">
          <span className="app-footer__copyright">
            © Copyright 2026 - WASH.PASS. Todos os direitos reservados.
          </span>
        </div>
      </footer>
    );
  }

  return (
    <footer className="app-footer app-footer--simple">
      <span className="app-footer__company">
        Wash Serviços De Tecnologia Ltda. · CNPJ 52.472.237/0001-79
      </span>
      <div className="app-footer__simple-links">
        <a
          href="https://wash.app.br/client-privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="app-footer__link"
        >
          Política de privacidade
        </a>
        <span className="app-footer__link" onClick={() => navigate('/fale-conosco')}>
          Suporte
        </span>
      </div>
    </footer>
  );
}
